module.exports = __webpack_public_path__ + "static/bureau-cabinet-psychologue-montpellier-1.f897aec8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cabinet/bureau-cabinet-psychologue-montpellier-1.jpg
// module id = 437
// module chunks = 43000224873248